import { render } from "./TASK_OWNER_ASSIGMENT_NOTIFICATION.vue?vue&type=template&id=885061ca&ts=true"
import script from "./TASK_OWNER_ASSIGMENT_NOTIFICATION.vue?vue&type=script&lang=ts"
export * from "./TASK_OWNER_ASSIGMENT_NOTIFICATION.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__